import { useEffect, useState } from 'react';
import {
  readTrustedFormCertUrl,
  rememberTrustedFormCertUrl,
} from './leadComplianceTokens';

const TRUSTED_FORM_SRC_MATCH =
  'script[src*="cdn.trustedform.com/bootstrap.js"]';

type TrustedFormWindow = Window & {
  trustedFormCallback?: (token: string) => void;
};

/**
 * Injects the TrustedForm bootstrap script once `enabled` becomes true.
 * Disabling it later does not remove the script.
 */
const useActiveProspectScript = (enabled: boolean): string => {
  const [activeProspectScriptToken, setActiveProspectScriptToken] = useState(
    readTrustedFormCertUrl,
  );

  useEffect(() => {
    if (!enabled || typeof document === 'undefined') return;

    (window as TrustedFormWindow).trustedFormCallback = (token: string) => {
      rememberTrustedFormCertUrl(token);
      setActiveProspectScriptToken(token);
    };

    const existing = readTrustedFormCertUrl();
    if (existing) setActiveProspectScriptToken(existing);

    if (document.querySelector(TRUSTED_FORM_SRC_MATCH)) return;

    const l = new Date().getTime() + Math.random();
    const protocol = document.location.protocol === 'http:' ? 'http' : 'https';
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = `${protocol}://cdn.trustedform.com/bootstrap.js?provide_referrer=false&field=xxTrustedFormCertUrl&l=${l}&invert_field_sensitivity=false&use_tagged_consent=true`;
    document.body.appendChild(script);
  }, [enabled]);

  return activeProspectScriptToken;
};

export default useActiveProspectScript;
